import React from 'react';

import Dashboard from '../dashboard-cli';

export default function DashboardClient({ children, ...props }) {

  return (
    <Dashboard props={props}>{children}</Dashboard>
  );
}
